import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import CheckboxGroupField from '../../../../shared/components/CheckboxGroupField'
import { Label } from '../../../../shared/compass-ui'
import ControlledNumericInput from '../../../shared/ControlledNumericInput'
import ControlledSelect from '../../../shared/ControlledSelect'
import TextInputError from '../../../shared/TextInputError'
import HiddenFieldMirror from '../../../shared/HiddenFieldMirror'

const INDUSTRY_OPTIONS = [
  { label: 'Agriculture / Farming', value: 'agriculture' },
  { label: 'Construction / Trades', value: 'construction' },
  { label: 'Education', value: 'education' },
  { label: 'Entertainment / Media / Arts', value: 'entertainment' },
  { label: 'Finance / Banking / Insurance', value: 'finance' },
  { label: 'Food Service / Hospitality', value: 'food_service' },
  { label: 'Government / Public Service', value: 'government' },
  { label: 'Healthcare / Medical', value: 'healthcare' },
  { label: 'Information Technology', value: 'information_technology' },
  { label: 'Legal / Law', value: 'legal' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Military / Armed Forces', value: 'military' },
  { label: 'Non-Profit / Social Services', value: 'non_profit' },
  { label: 'Real Estate', value: 'real_estate' },
  { label: 'Retail / Sales', value: 'retail' },
  { label: 'Transportation / Logistics', value: 'transportation' },
  { label: 'Utilities / Energy', value: 'utilities' },
  { label: 'Other', value: 'other' },
]

const WORK_TYPE_OPTIONS = [
  { label: 'Business Owner', value: 'business_owner' },
  { label: 'Freelancer / Independent Contractor', value: 'freelancer' },
  { label: 'Consultant', value: 'consultant' },
  { label: 'Other', value: 'other' },
]

const SelfEmploymentDetails: FC = () => {
  const {
    register,
    formState: {
      errors: {
        industry: industryError,
        selfEmploymentDuration: selfEmploymentDurationError,
        workType: workTypeError,
      },
    },
    clearErrors,
  } = useFormContext()

  return (
    <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-6">
      <HiddenFieldMirror name="industry" />
      <HiddenFieldMirror name="workType" />
      <div>
        <ControlledSelect
          id="industry-select"
          name="industry"
          label={EXTRA_QUESTION_LABELS.industry}
          options={INDUSTRY_OPTIONS}
          error={typeof industryError?.message === 'string'}
          errorId="industry-error"
          registerOptions={{
            onChange: () => {
              if (industryError) clearErrors('industry')
            },
          }}
        />
        {typeof industryError?.message === 'string' && (
          <TextInputError id="industry-error">This field is required</TextInputError>
        )}
      </div>
      <div>
        <Label htmlFor="self-employment-duration-input">
          {EXTRA_QUESTION_LABELS.selfEmploymentDuration}
        </Label>
        <ControlledNumericInput
          name="selfEmploymentDuration"
          id="self-employment-duration-input"
          suffix="years"
        />
        {typeof selfEmploymentDurationError?.message === 'string' && (
          <TextInputError>{selfEmploymentDurationError.message}</TextInputError>
        )}
      </div>
      <div>
        <CheckboxGroupField
          name="workType"
          label={EXTRA_QUESTION_LABELS.workType}
          options={WORK_TYPE_OPTIONS}
          hasError={typeof workTypeError?.message === 'string'}
          errorId="workType-error"
          inputProps={register('workType')}
        />
        {typeof workTypeError?.message === 'string' && (
          <TextInputError id="workType-error">This field is required</TextInputError>
        )}
      </div>
    </div>
  )
}

export default SelfEmploymentDetails
